module.exports = __webpack_public_path__ + "img/a-games.2698c031.png";